import { UseQueryOptions, useQuery } from 'react-query';
import { PositionBookmarkListItemVO } from '@domain/vo/common/PositionBookmarkListItemVO';
import { RemoteBookmarkRepo } from './BookmarkRepo';

const repo = new RemoteBookmarkRepo();

const fetchBookmarkStatus = async () => {
  const { data } = await repo.getBookmarkStatus();
  return data;
};

export const useBookmarkStatus = (options?: UseQueryOptions) => {
  return useQuery(['bookmark', 'status'], fetchBookmarkStatus, options as any);
};

const fetchPositionBookmarks = async () => {
  const { data } = await repo.getPositionBookmarks();
  return {
    ...data,
    positionBookmarks: data?.bookmarks.map(
      (item) =>
        new PositionBookmarkListItemVO({
          ...item,
          sn: item.positionSn,
          title: item.positionName,
        }),
    ),
  };
};

export const usePositionBookmarks = () => {
  return useQuery(['bookmark', 'position'], fetchPositionBookmarks);
};

const fetchJobPostBookmarks = async () => {
  const { data } = await repo.getJobPostBookmarks();
  return data;
};

export const useJobPostBookmarks = (options?: UseQueryOptions) => {
  return useQuery(['bookmark', 'jobPost'], fetchJobPostBookmarks, options as any);
};

const fetchCompanyBookmarks = async () => {
  const { data } = await repo.getCompanyBookmarks();
  return data;
};

export const useCompanyBookmarks = () => {
  return useQuery(['bookmark', 'company'], fetchCompanyBookmarks);
};
